class OnEvent {
  constructor(node, options = {}) {
    this.props = {
      name: 'event',
      eventName: undefined,
      duration: 1000,
      delay: 0,
      props: [],
      ...options,
    };

    if (!this.props.eventName) return;

    this.node = node;
    this.node.decorator = this;
    this.timeout = null;

    this.node.classList.add(`${this.props.name}-enter`);
    this.bindEvent();
  }

  bindEvent = () => {
    window.addEventListener(this.props.eventName, this.eventHandler);
  };

  removeClasses = e => {
    const { props } = this.props;

    if (!this.timeout) return;

    if (e) {
      if (props && props.length > 0) {
        if (props.indexOf(e.propertyName) !== -1) {
          clearTimeout(this.timeout);
          this.timeout = null;
          this.node.classList.remove(`${this.props.name}-enter`);
          this.node.classList.remove(`${this.props.name}-enter-active`);
        }
      } else {
        clearTimeout(this.timeout);
        this.timeout = null;
        this.node.classList.remove(`${this.props.name}-enter`);
        this.node.classList.remove(`${this.props.name}-enter-active`);
      }
    } else {
      clearTimeout(this.timeout);
      this.timeout = null;
      this.node.classList.remove(`${this.props.name}-enter`);
      this.node.classList.remove(`${this.props.name}-enter-active`);
    }
  };

  eventHandler = event => {
    this.timeout = setTimeout(
      this.removeClasses,
      this.props.delay + this.props.duration + 100
    );

    setTimeout(() => {
      this.node.addEventListener('transitionend', this.removeClasses);
      this.node.classList.add(`${this.props.name}-enter-active`);
    }, this.props.delay);
  };
}

export default (node, props) => new OnEvent(node, props);
